import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getRouteToName, imageFrom } from '../../util';
import { HtmlComponent, Image } from '..';
import { PropTypes } from 'prop-types';
import { translate } from '../../services';
import classNames from 'classnames';
import { siteSettingsState, currentNodeState, combineStates, combineDispatchers } from '../../store';
import { NodeMessage } from '../../components';
import { popupState } from '../../store';
import { popupDispatcher } from '../../store';
import { HelpImageViewer } from '../HelpImageViewer';
import { helpImage } from '../../util';

export class CategoryItemComponent extends Component {

  nodeMsg( item ) {
    if ( item.customProperties.nodeMessage && !this.props.popup?.map( v => v.disclaimer ).firstOrDefault() ) {
    // if ( item.nodeId == '9AAC100200' && !this.props.popup?.map( v => v.disclaimers ).firstOrDefault() ) {
      // <div>
      //   {
      //     <HelpImageViewer selectorName={ "Disclaimer" } filterName= { '1' } displayName={ item.name } />
      //   }
      // </div>
    this.nodePopup( item )
    }
  }

  nodePopup( item ) {
    this.props.setPopup( {
      title: translate( 'Disclaimer' ),
      component: <NodeMessage item={ item } />,
      showHeader: true,
      keepOpen: false,
      disclaimers: true
    } );
  }
  
  render() {
    const { item, siteSettings = {}, currentNode } = this.props;
    const { hideSubtext = false } = siteSettings;
    const showFullDescription=this.props?.siteSettings?.properties?.showFullDescription;
    var tileDescription='';
    const tileImage = <div className="category-view">
      <Image source={ imageFrom( item.image ) } alt={ translate( item.name ) } isIE/>
    </div>;

  let tileName = <div className="category-description">
      <HtmlComponent item={ item } tooltip={ item.name }/>
    </div>;
    if(showFullDescription){
       tileDescription = <div className="category-full-description">
        { translate(item.description) } 
      </div>
    tileName = <div className="category-description">
         <HtmlComponent item={ item } tooltip={ item.name }/>
       <div className="category-full-description">
         { translate(item.description) } 
      </div>
  </div>;
    }
    else{
       tileDescription = <div className="category-full-description">
      { translate(item.description) } 
    </div>
    }
    if(showFullDescription){
      const itemClassNames = classNames( { 
        'category-item-description-view': !hideSubtext && item.description && item.description.length 
      }, 'category-item' );
      // , 'category-item-dk' );
      if ( item.isExternal ) {
        return <a href={ item.libraryLink } target={ '_blank' } className={ itemClassNames }>
          { tileImage }
          { tileDescription } 
          { tileName }
        </a>;
      }
    return  <Link onClick={ this.nodeMsg.bind( this, item ) } to={ getRouteToName( item ) } className={ itemClassNames }>
      { tileImage }
      { tileDescription }
      { tileName }
    </Link>;
    }
    else{
      const itemClassNames = classNames( { 
        'category-item-description-view': !hideSubtext && item.description && item.description.length 
      }, 'category-item' );
      if ( item.isExternal ) {
        return <a href={ item.libraryLink } target={ '_blank' } className={ itemClassNames }>
          { tileImage }
          { tileDescription } 
          { tileName }
        </a>;
      }
      return <Link to={ getRouteToName( item ) } className={ itemClassNames }>
      { tileImage }
      { tileDescription }
      { tileName }
    </Link>;
    }
    
  }
}

CategoryItemComponent.propTypes = {
  item: PropTypes.shape( {
    image: PropTypes.string
  } ),
  currentNode: PropTypes.shape( {
    children: PropTypes.array,
    parent: PropTypes.object
  } ),
  node: PropTypes.shape( {} ),
  siteSettings: PropTypes.shape( {
    hideSubtext: PropTypes.bool
  } )
};
export const CategoryItem = connect( combineStates( siteSettingsState, currentNodeState, popupState ), combineDispatchers( popupDispatcher ) )
( CategoryItemComponent )